
























































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseListItem from '@shared/components/@atoms/BaseListItem/BaseListItem.vue';
import BaseLoader from '@shared/components/@atoms/BaseLoader/BaseLoader.vue';
import BaseList from '@shared/components/@organisms/BaseList/BaseList.vue';
import { IContactFormField } from '@shared/components/@organisms/UCContactForm/types';
import clickOutside from 'vue-click-outside';

import BaseSearchBar from '../BaseSearchBar/BaseSearchBar.vue';

export default defineComponent({
  name: 'UCContactFormVehicleSearchField',
  directives: {
    clickOutside,
  },
  components: {
    BaseSearchBar,
    BaseLoader,
    BaseList,
    BaseListItem,
  },
  props: {
    field: {
      type: Object as PropType<IContactFormField>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Error,
      default: null,
    },
    vehicles: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data() {
    return {
      searchValue: '',
      isSearchResultOpen: false,
      isChecked: false,
    };
  },
  computed: {
    searchIcon(): object {
      let icon = 'search';
      return {
        icon,
        size: 'var(--font-size--base)',
        color: 'var(--c-primary-400)',
      };
    },
  },
  methods: {
    searchInput(this: any, input: string): void {
      if (!/\S/.test(input)) {
        // if input only contains spaces, don't execute search
        this.closeSearchResults();
        return;
      }

      this.isSearchResultOpen = true;
      this.$emit('on-vehicle-search-input', input);
    },
    closeSearchResults(): void {
      this.isSearchResultOpen = false;
    },
    onEnter(): void {
      this.searchInput(this.searchValue);
    },
    closeIconClick(): void {
      this.searchValue = '';
      this.closeSearchResults();
    },
    vehicleSearchSelection(vehicleName: string) {
      this.searchValue = vehicleName;
      this.isSearchResultOpen = false;
      const inputField = this.field;
      inputField.value = vehicleName;
      inputField.mappedLabel = this.field.label;
      this.$parent.$emit('updated-input', inputField);
    },
    manualVehicleSelection(event: Record<string, unknown>) {
      const target = event.target as HTMLInputElement;
      const inputField = this.field;
      inputField.value = target.value;
      inputField.mappedLabel = this.field.label;
      this.$parent.$emit('updated-input', inputField);
    },
    toggleManualVehicleField() {
      this.isChecked = !this.isChecked;

      if (this.isChecked) {
        return;
      }
      // if user unchecks the checkbox, form checks for any value added in the search input text or returns empty string
      const inputField = this.field;
      inputField.value = this.searchValue || '';
      inputField.mappedLabel = this.field.label;
      this.$parent.$emit('updated-input', inputField);
    },
  },
});
